<script setup lang="ts">
import DottedMap from "dotted-map";

const map = new DottedMap({ height: 55, grid: "diagonal" });
const points = map.getPoints();

const svgOptions = {
  color: "currentColor",
  radius: 0.15,
};

const viewBox = "0 0 120 60";
</script>

<template>
  <svg :viewBox="viewBox" class="w-full h-auto">
    <circle
      v-for="(point, index) in points"
      :key="index"
      :cx="point.x"
      :cy="point.y"
      :r="svgOptions.radius"
      :fill="svgOptions.color"
    />
  </svg>
</template>
